<template>

  <div class="rows">

    <div class="row" v-for="materiel in materiels.data" v-bind:key="materiel.id">
      <div class="col-xs-4">
        <span class="title-item">Numero unique</span>
        <span class="text-item">{{materiel.nom}}</span>
      </div>
      <div class="col-xs-3">
        <span class="title-item">Arrondissement de rattachement</span>
        <span class="text-item">
          {{ materiel.arrondissement_id | arrondissementName }}
        </span>
      </div>
      <div class="col-xs-3">
        <span class="title-item">Type</span>
        <span class="text-item">
          {{ materiel.materielType }}
        </span>
      </div>
      <div class="col-xs-2">
        <div class="actions">
          <a class="action-edit" v-on:click="$emit('edit', materiel)">
            <img src="../../../../static/img/edit-icon.svg">
          </a>
          <a class="action-delete right-separator" v-on:click="$emit('delete', materiel)">
            <img src="../../../../static/img/delete-icon.svg">
          </a>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import {materielTypeV2} from '../../../filters'

export default {
  methods: {materielTypeV2},
  computed: {
    ...mapState([
      'currentVille',
      'materiels'
    ]),
  },
  mounted: function () {
    this.$store.dispatch('fetchMaterielsByVilleId')
    this.$store.dispatch('fetchMaterielPermissByVilleId')
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// MaterielList.vue?fb1f8e52